// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle[data-v-4a176ec4]{display:inline-block;line-height:25px;min-height:25px}.toggle__text[data-v-4a176ec4]{cursor:pointer;margin-left:5px;padding:5px 0 0;transition:all .3s ease-in-out}.toggle:hover .toggle__text[data-v-4a176ec4]{color:var(--c-original-green)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
